// Reply/forward prefixes other clients add: Outlook's "RE:"/"FW:", plus
// German (AW/WG), Nordic (SV/VS), Dutch (Antw/Doorst) and bracketed counts ("Re[2]:").
const REPLY_PREFIX = /^\s*(?:re|aw|sv|antw|ref)(?:\s*\[\d+\])?\s*:\s*/i;
const FORWARD_PREFIX = /^\s*(?:fwd?|wg|vs|doorst|tr)(?:\s*\[\d+\])?\s*:\s*/i;

function stripPrefixes(subject: string, pattern: RegExp): string {
    let rest = subject;
    while (pattern.test(rest)) rest = rest.replace(pattern, "");
    return rest.trim();
}

/** "RE: Re: RE: Hello" → "Re: Hello" — exactly one reply prefix, however many the thread collected. */
export function replySubject(subject: string | null | undefined): string {
    return `Re: ${stripPrefixes(subject ?? "", REPLY_PREFIX)}`;
}

/** "FW: Fwd: Hello" → "Fwd: Hello". */
export function forwardSubject(subject: string | null | undefined): string {
    return `Fwd: ${stripPrefixes(subject ?? "", FORWARD_PREFIX)}`;
}

/** Collapse a stacked reply prefix on an existing subject; anything else is left alone. */
export function tidySubject(subject: string | null | undefined): string {
    const value = subject ?? "";
    return REPLY_PREFIX.test(value) ? replySubject(value) : value;
}
